import React from 'react'
import { FormInstance } from 'antd/lib/form'

const EditableContext = React.createContext<FormInstance | null>(null)
export default EditableContext
